<ng-container *ngIf="dataFormulario;else spinner2">



<form class="bg-white p-3" [formGroup]="dataFormulario">
    <!-- ROW CAUSA Y TAREA-->
    <div class="form-row mb-2">
        <div class="col-12 col-lg-6 alinear">
            <label for="" class="label">{{"action_plan.plan_development.causes" | translate}}</label> <span *ngIf="!disabled"
                class="fa-stack fa-1x ml-lg-2 cursor" style="font-size: 13px;"
                (click)="!disabled?openModal('causas'):null">
                <i class="fa fa-circle fa-stack-2x icon-background"></i>
                <ng-container *ngIf="!loadingCauses;else spinner">
                    <i class="fas fa-plus fa-stack-1x"></i>
                </ng-container>


                <ng-template #spinner>
                    <fa-icon icon="spinner" style="margin-left:7px" [spin]="true"></fa-icon>
                </ng-template>
            </span>
            <div class="input-group" style="width: 101% !important;">
                <input type="text" class="form-control form-grey" formControlName="causas" [ngClass]="{ 'error': dataFormulario.get('causas').hasError('required')  &&
                    dataFormulario.get('causas').touched }" readonly (change)="edit()">
                <div class="input-group-append invisible">
                    <span class="input-group-text label"><i style="color:#126db3"
                            class="fas fa-user-friends"></i></span>
                </div>
            </div>

        </div>
        <div class="col-12 col-lg-2">
            <label for="" class=" label">{{"action_plan.plan_development.priority" | translate}}</label>
            <span  class="fa-stack fa-1x ml-lg-2 cursor invisible" style="font-size: 13px;">
                <i class="fa fa-circle fa-stack-2x icon-background"></i>
                <i class="fas fa-plus fa-stack-1x"></i>
            </span>

            <select class="form-control form-grey" formControlName="prioridad"  [ngClass]="{ 'error': dataFormulario.get('prioridad').hasError('required')  &&
                dataFormulario.get('prioridad').touched,'no-arrow':disabled}" (change)="edit()">
                <option value=2>{{"action_plan.plan_development.priority_values.high" | translate}}</option>
                <option value=1>{{"action_plan.plan_development.priority_values.medium" | translate}}</option>
                <option value=0>{{"action_plan.plan_development.priority_values.low" | translate}}</option>
            </select>
        </div>
    </div>
    <!-- ROW RESPONSABLES-->
    <div class="form-row mb-2">
        <div class="col-12 col-lg-6 alinear">
            <label for="responsable" class=" label">{{"action_plan.plan_development.responsible" | translate}}</label>
            <span *ngIf="!disabled" class="fa-stack fa-1x ml-lg-2 cursor" style="font-size: 13px;"
                (click)="!disabled?openModal('responsable'):null">
                <i class="fa fa-circle fa-stack-2x icon-background"></i>
                <i class="fas fa-plus fa-stack-1x"></i>
            </span>
            <div class="input-group" style="width: 101% !important;">

                <!-- <mat-autocomplete #auto="matAutocomplete">
                    <mat-option *ngFor="let option of members" [value]="option">
                        {{option}}
                    </mat-option>
                </mat-autocomplete> -->
                <input type="text" formControlName="responsable" [ngClass]="{ 'error': dataFormulario.get('responsable').hasError('required')  &&
                dataFormulario.get('responsable').touched }" class="form-control form-grey" readonly (change)="edit()">


                <div class="input-group-append invisible">
                    <span class="input-group-text label"><i style="color:#126db3"
                            class="fas fa-user-friends"></i></span>
                </div>
            </div>
        </div>
        <div class="col-12 col-lg-6">
            <label for="" class=" label">{{"action_plan.plan_development.co_responsible" | translate}}</label> <span
            *ngIf="!disabled"
                class="fa-stack fa-1x ml-lg-2 cursor" style="font-size: 13px;"
                (click)="!disabled?openModal('corresponsable'):null">
                <i class="fa fa-circle fa-stack-2x icon-background"></i>
                <i class="fas fa-plus fa-stack-1x"></i>
            </span>
            <div class="input-group">
                <!--
                <mat-autocomplete #auto2="matAutocomplete" [displayWith]="getOptionText">
                    <mat-option *ngFor="let option of members" [value]="option.id">
                        {{option.name}}
                    </mat-option>
                </mat-autocomplete> -->
                <input type="text" class="form-control form-grey" formControlName="corresponsable" readonly
                    (change)="edit()">
                <!-- <div class="input-group-append">
                    <span class="input-group-text label"><i style="color:#126db3"
                            class="fas fa-user-friends"></i></span>
                </div> -->
            </div>
        </div>
    </div>
    <!-- ROW FECHAS -->
    <label for="" class="label label-fecha">{{"action_plan.plan_development.dates" | translate}}</label>
    <div class="form-row form-grey p-2">
        <div class="col-12 col-lg-3">
            <label for="" class=" label">{{"action_plan.plan_development.notification" | translate}}</label>
            <div class="input-group">
                <input type="text" class="form-control" (bsValueChange)="datechanges($event)" 
                    formControlName="fecha_notificacion" bsDatepicker 
                    [bsConfig]="{ dateInputFormat: format,adaptivePosition:true}" [ngClass]="{ 'error': dataFormulario.get('fecha_notificacion').hasError('required')  &&
                    dataFormulario.get('fecha_notificacion').touched }" triggers="keydown:click" #dp1="bsDatepicker">
                <div class="input-group-append">
                    <span class="input-group-text label calendar"><i style="color:#909294;cursor:pointer"
                            class="far fa-calendar-alt" (click)="dp1.show()"></i></span>
                </div>
            </div>
        </div>
        <div class="col-12 col-lg-3">
            <label for="" class=" label">{{"action_plan.plan_development.planned_start" | translate}}</label>
            <div class="input-group">
                <input type="text" class="form-control" (bsValueChange)="datechanges()" formControlName="fecha_inicio"
                    bsDatepicker 
                    [minDate]="fecha_notificacion?fecha_notificacion:dataFormulario.get('fecha_notificacion').value"
                    [bsConfig]="{ dateInputFormat: format,adaptivePosition:true}" [ngClass]="{ 'error': dataFormulario.get('fecha_inicio').hasError('required')  &&
                    dataFormulario.get('fecha_inicio').touched }"
                    [readOnly]="!this.dataFormulario.get('fecha_notificacion').value?true:false"
                    triggers="keydown:click" #dp="bsDatepicker">
                <div class="input-group-append">
                    <span class="input-group-text label calendar"
                        (click)="this.dataFormulario.get('fecha_notificacion').value?dp.show():null"><i
                            style="color:#909294;cursor:pointer" class="far fa-calendar-alt"></i></span>
                </div>
            </div>
        </div>
        <div class="col-12 col-lg-3">
            <label for="" class=" label">{{"action_plan.plan_development.planned_end" | translate}}</label>
            <div class="input-group">
                <input type="text" class="form-control" (bsValueChange)="datechanges('fecha_fin')"
                    [minDate]="fecha_inicio?fecha_inicio:this.dataFormulario.get('fecha_inicio').value"
                    formControlName="fecha_fin" bsDatepicker  
                    [bsConfig]="{ dateInputFormat: format,adaptivePosition:true}" [ngClass]="{ 'error': dataFormulario.get('fecha_fin').hasError('required')  &&
                    dataFormulario.get('fecha_fin').touched }"
                    [readOnly]="!this.dataFormulario.get('fecha_inicio').value?true:false" triggers="keydown:click"
                    #dp2="bsDatepicker">
                <div class="input-group-append">
                    <span class="input-group-text label calendar"
                        (click)="this.dataFormulario.get('fecha_inicio').value?dp2.show():null"><i
                            style="color:#909294;cursor:pointer" class="far fa-calendar-alt"></i></span>
                            <!-- onkeydown="event.preventDefault()" -->
                </div>
            </div>
        </div>
        <div class="col-12 col-lg-3">
            <div for="" class="form-label label ml-lg-5">{{"action_plan.plan_development.task_execution" | translate}}
            </div>

            <div class="form-check form-check-inline ml-lg-5 mt-2 ml-2">
                <label class="form-check-label">
                    {{ "action_plan.plan_development.yes" | translate }}
                </label>
                <input class="form-check-input ml-2" type="radio" formControlName="en_ejecucion" name="en_ejecucion"
                    value="1" [ngClass]="{ 'error': dataFormulario.get('en_ejecucion').hasError('required')  &&
                    dataFormulario.get('en_ejecucion').touched }" (change)="editCheck()">
            </div>
            <div class="form-check form-check-inline">
                <label class="form-check-label">
                    {{ "action_plan.plan_development.no" | translate }}
                </label>
                <input class="form-check-input ml-2" type="radio" formControlName="en_ejecucion" name="en_ejecucion"
                    value="0" [ngClass]="{ 'error': dataFormulario.get('en_ejecucion').hasError('required')  &&
                    dataFormulario.get('en_ejecucion').touched }"
                    [readOnly]="!this.dataFormulario.get('fecha_fin').value?true:false" (change)="editCheck()">
            </div>

        </div>

    </div>
    <div class="form-row form-grey p-2">
        <div class="col-12 col-lg-3">
            <label for="" class=" label">{{"action_plan.plan_development.execution" | translate}}</label>
            <div class="input-group">
                <input type="text" class="form-control" (bsValueChange)="datechanges()"
                    formControlName="fecha_ejecucion" bsDatepicker 
                    [bsConfig]="{ dateInputFormat: format,adaptivePosition:true}" [ngClass]="{ 'error': dataFormulario.get('fecha_ejecucion').hasError('required')  &&
                    dataFormulario.get('fecha_ejecucion').touched }"
                    [readOnly]="!this.dataFormulario.get('fecha_fin').value?true:false" triggers="keydown:click"
                    #dp3="bsDatepicker">
                <div class="input-group-append">
                    <span class="input-group-text label calendar"
                        (click)="this.dataFormulario.get('fecha_fin').value?dp3.show():null"><i
                            style="color:#909294;cursor:pointer" class="far fa-calendar-alt"></i></span>
                </div>
            </div>
        </div>
        <div class="col-12 col-lg-3">
            <label for="" class=" label">{{"action_plan.plan_development.validation" | translate}}</label>
            <div class="input-group">
                <input type="text" class="form-control" (bsValueChange)="datechanges()"
                    formControlName="fecha_validacion"
                    [minDate]="fecha_ejecucion?fecha_ejecucion:dataFormulario.get('fecha_ejecucion').value" bsDatepicker 
                    [bsConfig]="{ dateInputFormat: format,adaptivePosition:true}" [ngClass]="{ 'error': dataFormulario.get('fecha_validacion').hasError('required')  &&
                    dataFormulario.get('fecha_validacion').touched }"
                    [readOnly]="!this.dataFormulario.get('fecha_ejecucion').value?true:false" triggers="keydown:click"
                    #dp4="bsDatepicker">
                <div class="input-group-append">
                    <span class="input-group-text label calendar"
                        (click)="this.dataFormulario.get('fecha_ejecucion').value?dp4.show():null"><i
                            style="color:#909294;cursor:pointer" class="far fa-calendar-alt"></i></span>
                </div>
            </div>
        </div>

        <div class="col-12 col-lg-3">
            <div for="" class="form-label label">{{"action_plan.plan_development.closed_task" | translate}}
            </div>

            <div class="form-check form-check-inline mt-2 ml-1">
                <label class="form-check-label">
                    {{ "action_plan.plan_development.yes" | translate }}
                </label>
                <input class="form-check-input ml-2" (change)="changesClose($event)" type="radio"
                    formControlName="cerrada" name="cerrada" value="1" [ngClass]="{ 'error': dataFormulario.get('cerrada').hasError('required')  &&
                    dataFormulario.get('cerrada').touched }">
            </div>
            <div class="form-check form-check-inline">
                <label class="form-check-label">
                    {{ "action_plan.plan_development.no" | translate }}
                </label>
                <input class="form-check-input ml-2" (change)="changesClose($event)" type="radio"
                    formControlName="cerrada" name="cerrada" value="2" [ngClass]="{ 'error': dataFormulario.get('cerrada').hasError('required')  &&
                    dataFormulario.get('cerrada').touched }">
            </div>

        </div>
        <div class="col-12 col-lg-3 ">
            <!-- <div class="invisible">
                dada
            </div> -->
            <div class="row mr-4" style="margin-top:2px">
                <div class="col-6 pr-3">
                    <button class="btn  mt-3 mainColor text-white invisible" style="font-size: 13px;width:100px"
                        [disabled]="disabled">
                        {{ "action_plan.plan_development.bitacora" | translate }} {{nro}}
                    </button>

                </div>
                <div class="col-6" style="padding-left: 28px;">
                    <button class="btn  mr-4 mt-3 acceptButton text-white invisible" style="font-size: 13px;width:100px"
                        (click)="saveAction()" [disabled]="disabled">
                        <ng-container *ngIf="!saving;else spinner">
                            {{ "globals.buttons.save" | translate }}
                        </ng-container>


                        <ng-template #spinner>
                            <fa-icon icon="spinner" [spin]="true"></fa-icon>
                        </ng-template>
                    </button>
                </div>
            </div>

        </div>

    </div>

    <!-- ROW RECURSOS -->
    <label for="" class="label mt-2 label-recursos">{{"action_plan.plan_development.resources" | translate}}</label>
    <div class="form-row form-grey p-2">
        <div class="col-12 col-lg-4">
            <div class="form-group">

                <label for="" class=" label">{{"action_plan.plan_development.materials" | translate}}</label>
                <textarea class="form-control" formControlName="materiales" name="" maxlength=70
                    (change)="edit()"></textarea>
            </div>
        </div>
        <div class="col-12 col-lg-4">
            <div class="form-group">

                <label for="" class=" label">{{"action_plan.plan_development.services" | translate}}</label>
                <textarea class="form-control" formControlName="servicios" name="" maxlength=70
                    (change)="edit()"></textarea>
            </div>
        </div>
        <div class="col-12 col-lg-4">
            <label for="" class=" label">{{"action_plan.plan_development.costs" | translate}}</label>

            <input type="number" class="form-control" [ngClass]="{'no-number':disabled}" formControlName="costos" (keydown)="validate($event)" (change)="edit()">

        </div>
        <!-- <div class="col-12 col-lg-1">
            <div class="form-group">
                <label for="" class=" label">{{"action_plan.plan_development.unit" | translate}}</label>
                <select class="form-control" name="">
                    <option value=""></option>
                </select>
            </div>


        </div> -->

    </div>
    <!-- <div class="form-row mt-2">
        <div class="col-12 col-lg-2">
            <div class="form-group">
                <label for="" class="label">{{"action_plan.plan_development.priority" | translate}}</label>
                <select name="" class="form-control form-grey">
                    <option value=""></option>
                </select>
            </div>
        </div>

    </div> -->
    <div class="form-row mt-2">
        <div class="col-12 col-lg-12">
            <div class="form-group">
                <label for="" class="label">{{"action_plan.plan_development.notes" | translate}}</label>
                <textarea formControlName="notas" name="" class="form-control form-grey" (change)="edit()"></textarea>
            </div>
        </div>

    </div>
    <div class="form-row mt-2">
        <div class="col-12 d-flex justify-content-end" style="padding-left: 28px;">
            <button *ngIf="!disabled" class="btn  mr-4 mt-3 acceptButton text-white" style="font-size: 13px;width:100px"
                (click)="saveAction()" [disabled]="disabled">
                <ng-container *ngIf="!saving;else spinner">
                    {{ "globals.buttons.save" | translate }}
                </ng-container>


                <ng-template #spinner>
                    <fa-icon icon="spinner" [spin]="true"></fa-icon>
                </ng-template>
            </button>
        </div>

    </div>
</form>
</ng-container>
<ng-template #spinner2>
    <div class="col-12 d-flex justify-content-center">
        <fa-icon icon="spinner" style="color:#126db3;font-size: 20px;" [spin]="true"></fa-icon>

    </div>
</ng-template>
